import { useMemo } from "react";
import { PROFILE_LINKS, ADMIN_LINKS } from "./sidebar_nav_items";
import type { AccessRights, AdminNavItem, ProfileNavItem } from "./nav_item.types";

// The desktop sidebar and the More menu show the same two sections. Filtering them in
// one place stops the two copies from drifting apart when a role is added.
export const useNavSections = (accessRights: AccessRights, isAuthenticated: boolean) => {
	const profileItems = useMemo<ProfileNavItem[]>(() => {
		if (!isAuthenticated) return [];
		return PROFILE_LINKS.filter(
			item => !item.mentorOnly || accessRights.isMentor || accessRights.isLeader,
		);
	}, [isAuthenticated, accessRights.isMentor, accessRights.isLeader]);

	const adminItems = useMemo<AdminNavItem[]>(
		() => ADMIN_LINKS.filter(item => item.requiredAccess.some(access => accessRights[access])),
		[accessRights],
	);

	return { profileItems, adminItems };
};
